import api from "actions/api.js"


export function getCSV() {
    return api("export",
        {
            method: "POST"
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/export/api.js
 **/